import { Link, useLocation } from "react-router-dom";

export default function ProviderOrdersLayout({ children }) {
  const { pathname } = useLocation();

  const isActive = (path) =>
    pathname.startsWith(path)
      ? "tab tab-active text-primary font-semibold"
      : "tab text-primary";

  return (
    <div className="p-6 text-primary">
      <h1 className="text-3xl font-bold mb-6 text-primary">Commandes</h1>

      {/* Onglets */}
      <div role="tablist" className="tabs tabs-bordered mb-6 text-primary">
        {/*<Link to="/orders/services" className={isActive("/orders/services")}>
          Services
        </Link>

        <Link to="/orders/calendar" className={isActive("/orders/calendar")}>
          Calendrier
        </Link>*/}
      </div>

      {/* Contenu dynamique */}
      <div className="bg-base-100 border rounded-lg p-6 shadow-sm text-primary">
        {children}
      </div>
    </div>
  );
}
